import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider,
  EmailAuthProvider
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCwCKzQM_Cc-x-ezTH_r06fmwvV-AXzSFY",
  authDomain: "gifted-analyst-qk91c.firebaseapp.com",
  projectId: "gifted-analyst-qk91c",
  storageBucket: "gifted-analyst-qk91c.firebasestorage.app",
  messagingSenderId: "907973023186",
  appId: "1:907973023186:web:67dca258e07a1255a5e40b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services
export const auth = getAuth(app);
export const db = getFirestore(app, "ai-studio-driplee-bf8f89d7-70e7-401e-ab68-656a576e6167");

// Auth Providers
export const googleProvider = new GoogleAuthProvider();

export default app;
